import React from 'react';
import { browserHistory } from '../../../../browserHistory';
import { PageUiNavBar } from '../../../../components/Layout/PageNavBar/PageUiNavBar';

export enum ScanView {
  COMBO = 'scan',
  LEADERBOARD = 'scan-leaderboard',
  LINEHAUL = 'scanLinehaul',
  GRAPHS = 'scan-graphs',
  GRAPH_PER_STORE = 'scan-graphs-per-store',
}

function getUrlActive(): string {
  const activePage: string = browserHistory?.location?.pathname;
  const urlList: string[] = activePage?.split('/');
  const urlActive: string =
    urlList && urlList.length
      ? urlList[urlList.length - 1]
      : ScanView.LEADERBOARD;
  return urlActive;
}
export function ScanMenuButtons(): JSX.Element {
  const urlActive: string = getUrlActive();

  return (
    <PageUiNavBar
      bars={[
        {
          text: 'Combo',
          page: `monitor/${ScanView.COMBO}`,
          method: () => {
            browserHistory.push(`/monitor/${ScanView.COMBO}`);
          },
          active: urlActive === ScanView.COMBO.toString(),
        },

        {
          text: 'Leaderboard',
          page: `monitor/${ScanView.LEADERBOARD}`,
          method: () => {
            browserHistory.push(`/monitor/${ScanView.LEADERBOARD}`);
          },
          active: urlActive === ScanView.LEADERBOARD.toString(),
        },

        {
          text: 'Line-haul',
          page: `monitor/${ScanView.LINEHAUL}`,
          method: () => {
            browserHistory.push(`/monitor/${ScanView.LINEHAUL}`);
          },
          active: urlActive === ScanView.LINEHAUL.toString(),
        },
        {
          text: 'Cage sort',
          page: `monitor/${ScanView.GRAPHS}`,
          method: () => {
            browserHistory.push(`/monitor/${ScanView.GRAPHS}`);
          },
          active: urlActive === ScanView.GRAPHS.toString(),
        },

        {
          text: 'Retail sort',
          page: `monitor/${ScanView.GRAPH_PER_STORE}`,
          method: () => {
            browserHistory.push(`/monitor/${ScanView.GRAPH_PER_STORE}`);
          },
          active: urlActive === ScanView.GRAPH_PER_STORE.toString(),
        },
      ]}
    />
  );
}
